import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getQuote } from '../../../features/quote/QuoteSlice';
import { Field } from '../../../types';
import Tooltip from '../Tooltip';

export interface CheckboxProps {
    field: Field;
    error?: string;
    inputRef: any
}
function Checkbox(props: CheckboxProps) {
  const { field, error, inputRef } = props;
  const { data } = useSelector(getQuote);
  const { setValue } = useFormContext();
  useEffect(() => {
    setValue(
      inputRef.name,
      data[field.formId] || (field.attributes && field.attributes.checked ? (field.value || 'on') : false),
    );
  }, []);

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <div className="form-check ps-5">
        <input
          defaultChecked={(field.attributes && field.attributes.checked === 'checked') || data[field.formId]}
          id={field.formId}
          value={field.value || 'on'}
          {...inputRef}
          className="form-check-input"
          type="checkbox"
        />
        <label className="form-check-label" htmlFor={field.id}>
          {field.label}
          {field.required
            && <span className="ms-2 d-inline-block asterix">*</span>}
        </label>
      </div>

      <div className="form-card-footer d-flex  justify-content-end">
        {
                    error
                    && <small className="error ">{error}</small>
                }
        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
    </div>
  );
}

Checkbox.defaultProps = {
  error: false,
};

export default Checkbox;
